(function($) {

$(function() {
    initialize();
    registerForLocationEvent();
});

function initialize() {
    var $container = $('#map');
    if ($container.length == 0) {
        return;
    }

    var container = $container[0];
    var options = {
        'center': { 'lat': 43.4667, 'lng': -80.5167 },
        'zoom': 8
    };
    var map = new google.maps.Map(container, options);
    $container.data('map', map);

    var markers = [];

    $('.location').each(function() {
        var $location = $(this);
        var title = $location.data('title');
        var string = $location.data('location');
        var coordinates = createGoogleMapsCoordinatesFromString(string);
        if (coordinates) {
            var marker = createGoogleMapsMarker(map, title, coordinates);
            markers.push(marker);
            $location.data('marker', marker);
        }
    });

    center(map, markers)
}

function center(map, markers) {
    var bounds = new google.maps.LatLngBounds ();
    for (var i = 0; i < markers.length; i++) {
        var marker = markers[i];
        bounds.extend(marker.position);
    }
    map.fitBounds(bounds);
}

function createGoogleMapsCoordinatesFromString(string) {
    var segments = string.split(',');
    if (segments.length == 2) {
        var latitude = segments[0];
        var longitude = segments[1];
        return new google.maps.LatLng(latitude, longitude);
    }
}

function createGoogleMapsMarker(map, title, coordinates) {
    if (coordinates) {
        return new google.maps.Marker({
            'icon': createGoogleMapsMarkerIcon(false),
            'map': map,
            'position': coordinates,
            'title': title
        });
    }
}

function createGoogleMapsMarkerIcon(highlighted) {
    var data = '';
    if ( ! highlighted) {
        data = 'data:image/png;base64,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';
    } else {
        data = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAABMCAYAAAA4NXTJAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA8pJREFUeNrsW4GxmzAMNZ2AEdggjMAIjEAnaDpB6QR0A0bIZQKyQZIJSCbgb0CtHumBI4Ms2+DcoTvdv58jxM/PsvRkEGK33XbbbbfdtBb5vHnf97H8k0pPBh/bl/Sb9EcURY+PmTEJKpNeSW97usG1tfQ8ZGCFISidddLLgf0ggOWOgKFAN4vBYYZr6bPL6na7icfjIe73++Tzw+Eg4jgWWZYt/RTE6XcZp7c1WUvnWDudTn1RFL0E0MPlS57neV/Xdd913Ryb+Zrg0JHAIJMkIYHCHCakLMs5oMUm4K7Xa5+mKRsYBhRWwaogdeCANepSNPXj8agDmbsGF2MxB+B8ABs7xLImJlOXAE9bgFsAeXVZmbztkmuBW1iuRxcAJ0uzbVtvMbfkyMbTWVU8Q/k1MZmYWYOD9AHfBefuuDCxSAopbQA24zs1TcPKa8D629TLgXLyJtxPvRUXXGLDHlQnMwl7SoEctCWLOQfgUY09y11v1kx2ZbhW/bp1aqDOMrA8Y83gnQ2TyG+0HIAdZ3li8Ybpu2EDewNKjUnEYlOAE7NYmoVJ+UddqrDhqVsEO7lT4w/JU7VprMMGwoxDdCK/UQCDYKUYIl5/LyruKPoz/h9EsMyTi7/1fD7VjxI2QKrB4JTBU7tll7n72JhTgDZz4+vGTgGqS5mSgEe9U+OQcAaQEhP/1tnlon70g/C1Xyo4CkBoWiHNKX6aoCgITZKvTYp5arKHNgk7TWAyCWpLZn56VTC5kv9qrACnTCRc4yLR15wEDJUItch+q5iJk4gUFObqXl0+1NkFB71nChIGTS22kVVScRtNHVfWAJOa5dqrVZKJDNPEecLVhCWXxfGAYHmPi3C4z6v7barqkUlrbNuFbBZdu4a9zCpRqpuNifB17UiB3VhXAljrgrO0bB1i2jl7IbGIsHd1Vs9tzaKGPbeHMFuyWFWVfQ+G08LnNoEdNHu9HaFZNYI5jjR6W+HL1mbReas+NBaxNr33x0uGx0Ym5vL4eqHH6pc9nVb0cRiKSCL/7M0pcZunK4jsVWJN88mipkOerA3QG4tIv6UWW5gqpaDi8CSJkq0AWgtigqDdhj0fgtiLoA2JRaftiNBY9CpoQ5BSXtoRoQhiDXthPb9twyLCXitCMy6LmnOGQoRoHBZXFbQ+BPHcgYrmoKYQIZsqiAEABhI0JFJzOpdEkQ8W5Z+3LR5eLzifz/9PZyVo7Os/1acuQmWxZBwP1uKTzBDkZ4FTNp1m4aUsrwk9Wgko6DmIzZeug1frLqu+rrPbbrvt5sP+CjAAdeGrONuXE/IAAAAASUVORK5CYII=';
    }
    return {
        'url': data,
        'scaledSize': new google.maps.Size(28, 38)
    };
}

function registerForLocationEvent() {
    var $container = $('#map');
    var map = $container.data('map');

    $('.location-hover').mouseover(function() {
        var $location = $(this);
        var marker = $location.data('marker');
        updateGoogleMapsMarkerWithState(marker, true);
    });

    $('.location-hover').mouseout(function() {
        var $location = $(this);
        var marker = $location.data('marker');
        updateGoogleMapsMarkerWithState(marker, false);
    });
}

function updateGoogleMapsMarkerWithState(marker, state) {
    if (marker) {
        var icon = createGoogleMapsMarkerIcon(state);
        marker.setIcon(icon);
    }
}

})(jQuery);
